import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Login from './componentes/login/Login';
import Bienvenido from './componentes/app/Bienvenido';
import CambioContrasenaComponent from './componentes/app/CambioContrasenaComponent';

export default class App extends Component {
    constructor() {
        super();
        this.state={};
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route path="/dif" component={Login} exact />
                    <Route path="/dif/bienvenido" component={Bienvenido} />
                    <Route path="/dif/cambiocontrasenacomponent/:id?" component={CambioContrasenaComponent} />
                </Switch>
            </BrowserRouter>
        );
    }
}